<template>
    <section class="cv_short">
        <slot></slot>
        <div class="container" v-b-toggle.collapse_short v-scroll-to="'#collapse_short'" tabindex="0" role="tab" >
            <h1>Short story...</h1>
            <article class="short">
                <h5>...of what I've learned and came to practice</h5>
            </article>
        </div>
    </section>
</template>

<script>
    export default {
        name: "CV-Short"
    }
</script>

<style scoped>
    .cv_short {
        height: 50vh;
        background-image: url("../assets/paper.jpg");
        background-size: cover;
        background-position: center;
        cursor: pointer;
        overflow: hidden;
        position: relative;
        transition: filter 0.5s ease;
        filter: grayscale(100%);

    }
    .container {
        height: 50vh;
        outline: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    h1 {
        font-size: 4vmax;
        font-weight: 700;
        color: white;
        text-shadow: 0 0 15px blue;
    }
    h5 {
        font-size: 2vmax;
        color: white;
        text-shadow: 0 0 8px yellow;
        padding-top: 20px;
    }
/*    check app.scss*/
</style>